// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__2a_Ot","path":"styles_path__34Zg3","active":"styles_active__3Ias0"};